module.exports = __webpack_public_path__ + "img/history_msg.2604b4bc.png";